import type { HeadingBlock } from "../../../services/educationService";
import styles from "./article.module.css";

export function ArticleHeading({ block }: { block: HeadingBlock }) {
	const Tag = (block.level === 3 ? "h3" : "h2") as "h2" | "h3";
	return <Tag className={styles.heading}>{block.text}</Tag>;
}
